import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { abyssColors } from '@/theme/colors';

type Props = {
  leftContent: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
  onBack?: () => void;
  closeAriaLabel?: string;
  closeId?: string;
  backAriaLabel?: string;
  backId?: string;
};

export const ReviewHeaderShell = ({
  leftContent,
  actions,
  onClose,
  onBack,
  closeAriaLabel = 'Close drawer',
  closeId,
  backAriaLabel = 'Back',
  backId,
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2rem 2.4rem',
        borderBottom: `0.1rem solid ${abyssColors.primary[200]}`,
      }}
    >
      <Stack direction="row" gap="1.6rem" alignItems="center">
        {onBack && (
          <IconButton
            size="small"
            onClick={onBack}
            disableRipple
            sx={{ padding: 0 }}
            aria-label={backAriaLabel}
            id={backId}
          >
            <ArrowBackIcon sx={{ color: abyssColors.primary[700] }} />
          </IconButton>
        )}
        {leftContent}
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="center">
        {actions}
        <IconButton
          size="small"
          onClick={onClose}
          disableRipple
          sx={{ padding: 0 }}
          aria-label={closeAriaLabel}
          id={closeId}
        >
          <CloseIcon sx={{ color: abyssColors.primary[700] }} />
        </IconButton>
      </Stack>
    </Box>
  );
};
